var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vs-table", class: _vm.classes },
    [
      _c("vs-table-header", {
        ref: "header",
        staticClass: "z-10 bg-white",
        class: { sticky: !_vm.notSticky },
        attrs: {
          processing: _vm.processing,
          headings: _vm.headings,
          "sort-column": _vm.sortColumn,
          "sort-direction": _vm.sortDirection,
          "header-top": _vm.headerTop
        },
        on: {
          sort: _vm.handleTableSort,
          "header-action": _vm.handleHeaderAction,
          help: function($event) {
            return _vm.$emit("help")
          }
        }
      }),
      _c("div", { staticClass: "vs-table__body" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }